// extracted by mini-css-extract-plugin
export default {"root":"Empty_root__8FY6E","imgStyle":"Empty_imgStyle__+ecVb","tip":"Empty_tip__X7P2F"};